export const AUTO_SUGGEST_Z_INDEX = 1;
